
import React, { useState } from 'react';
import styles from './ChooseRange.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import CalendarInput from '../../components/CalendarInput/CalendarInput';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import { HiOutlineCalendarDays } from 'react-icons/hi2';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

const ChooseRange = () => {
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleSetRange = () => {
    console.log('Set Range:', { fromDate, toDate });
  };

  const handleCancel = () => {
    setFromDate('');
    setToDate('');
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon
          icon={<HiOutlineCalendarDays />}
          heading="Choose Range"
        />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>
      <div className={styles.body}>
      <div className={styles.dateRow}>
        <CalendarInput
          fieldLabel="From"
          label="Choose from date"
          required={true}
          value={fromDate}
          onChange={(val) => setFromDate(val)}
        />
        <CalendarInput
          fieldLabel="To"
          label="Choose to date"
          required={true}
          value={toDate}
          onChange={(val) => setToDate(val)}
        />
      </div>

      <SaveAndCancel
        cancelLabel="Cancel"
        saveLabel="Set Range"
        onCancel={handleCancel}
        onSave={handleSetRange}
      />
    </div>
    </div>
  );
};

export default ChooseRange;
